(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

var _share_button = require('./public/components/share_button.js');

var _share_button2 = _interopRequireDefault(_share_button);

var _slider_contained_one_column = require('./public/sections/slider_contained_one_column.js');

var _slider_contained_one_column2 = _interopRequireDefault(_slider_contained_one_column);

var _responsive_slider = require('./public/sections/responsive_slider.js');

var _responsive_slider2 = _interopRequireDefault(_responsive_slider);

var _page_navigation = require('./public/sections/page_navigation.js');

var _page_navigation2 = _interopRequireDefault(_page_navigation);

var _heritage_slider = require('./public/sections/heritage_slider.js');

var _heritage_slider2 = _interopRequireDefault(_heritage_slider);

var _tile_travel_tabs = require('./public/items/tile_travel_tabs.js');

var _tile_travel_tabs2 = _interopRequireDefault(_tile_travel_tabs);

var _tile_column = require('./public/items/tile_column.js');

var _tile_column2 = _interopRequireDefault(_tile_column);

var _header = require('./public/header.js');

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import sticky_nav_init from './public/sticky.js';


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function init() {
				(0, _header2.default)($);
				(0, _share_button2.default)($);
				(0, _slider_contained_one_column2.default)($);
				(0, _responsive_slider2.default)($);
				(0, _heritage_slider2.default)($);
				//sticky_nav_init($);
			},
			finalize: function finalize() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				$("a[href^='http://bombaysapphire.admit-one.eu/']").attr("target", "_blank");
				$("a[href^='http://distillery.bombaysapphire.com/']").attr("target", "_blank");
				$('.in-page-footer').removeClass('contained_two_column');
			}
		},
		// Home page
		'home': {
			init: function init() {},
			finalize: function finalize() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		'location': {
			init: function init() {
				(0, _tile_travel_tabs2.default)($);
			}
		},
		'la_creation': {
			init: function init() {
				(0, _tile_column2.default)($);
			}
		},
		'la_collection': {
			init: function init() {
				(0, _page_navigation2.default)($);
			}
		},
		'lhistoire': {
			init: function init() {
				(0, _page_navigation2.default)($);
				(0, _tile_column2.default)($);
			}
		}

	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function fire(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function loadEvents() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

	function resize_video() {
		if ($(window).width() < 420) {
			var headerHeight = $('header').height();
			$('.component__video__container').css('min-height', '1px');
			$('.component__video__container').css('max-height', 'calc(100vh - ' + headerHeight + 'px)');

			$('.component__video__container video').css('min-height', '1px');
			$('.component__video__container video').css('max-height', 'calc(100vh - ' + headerHeight + 'px)');
		} else {
			$('.component__video__container').css('min-height', 'none');
			$('.component__video__container').css('max-height', 'none)');

			$('.component__video__container video').css('min-height', 'none');
			$('.component__video__container video').css('max-height', 'none');
		}
	}
	setTimeout(resize_video, 1000);
	window.onresize = resize_video;

	var scroll_last = 0;
	var current_scroll_distance = 0;

	$('.page__inner').scroll(function () {
		var scroll = $('.page__inner').scrollTop();

		current_scroll_distance += scroll_last - scroll;
		current_scroll_distance = Math.max(Math.min(current_scroll_distance, 0), -60);
		$('.header__bottom').css({ 'margin-top': current_scroll_distance });

		if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			$window.bind('mousewheel', function (e) {
				if (e.originalEvent.wheelDelta / 120 > 0) {

					if ($window.scrollTop() < 2) return false;
				}
			});
		} //	Fix the rubber band scroll issue on safari

		scroll_last = scroll;
	});
})(jQuery); // Fully reference jQuery after this point.
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_81c160ae.js","/")
},{"./public/components/share_button.js":2,"./public/header.js":3,"./public/items/tile_column.js":4,"./public/items/tile_travel_tabs.js":5,"./public/sections/heritage_slider.js":6,"./public/sections/page_navigation.js":7,"./public/sections/responsive_slider.js":8,"./public/sections/slider_contained_one_column.js":9,"buffer":11,"rH1JPG":13}],2:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = share_button_init;
function share_button_init($) {
	$('.share-buttons .cta').click(function (event) {
		if (!$(event.currentTarget).hasClass('open')) {
			$(event.currentTarget).addClass('open');
			$(event.currentTarget).parent().addClass('open');
			$(event.currentTarget).parent().find('.share-buttons').addClass('open');
		} else {
			$(event.currentTarget).removeClass('open');
			$(event.currentTarget).parent().removeClass('open');
			$(event.currentTarget).parent().find('.share-buttons').removeClass('open');
		}
		event.preventDefault();
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNoYXJlX2J1dHRvbi5qcyJdLCJuYW1lcyI6WyJzaGFyZV9idXR0b25faW5pdCIsIiQiLCJjbGljayIsImV2ZW50IiwiY3VycmVudFRhcmdldCIsImhhc0NsYXNzIiwiYWRkQ2xhc3MiLCJwYXJlbnQiLCJmaW5kIiwicmVtb3ZlQ2xhc3MiLCJwcmV2ZW50RGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBUyxBQUFULGtCQUEyQixBQUEzQixHQUE4QixBQUM1QztHQUFFLEFBQUYsdUJBQXlCLEFBQXpCLE1BQWlDLEFBQUQsaUJBQVcsQUFDMUM7TUFBSyxDQUFDLEVBQUUsTUFBTSxBQUFSLGVBQXVCLEFBQXZCLFNBQWdDLEFBQWhDLEFBQU4sU0FBK0MsQUFDOUM7S0FBRSxNQUFNLEFBQVIsZUFBdUIsQUFBdkIsU0FBZ0MsQUFBaEMsQUFDQTtLQUFFLE1BQU0sQUFBUixlQUF1QixBQUF2QixTQUFnQyxBQUFoQyxTQUF5QyxBQUF6QyxBQUNBO0tBQUUsTUFBTSxBQUFSLGVBQXVCLEFBQXZCLFNBQWdDLEFBQWhDLEtBQXFDLEFBQXJDLGtCQUF1RCxBQUF2RCxTQUFnRSxBQUFoRSxBQUNBO0FBSkQsU0FJTyxBQUNOO0tBQUUsTUFBTSxBQUFSLGVBQXVCLEFBQXZCLFlBQW1DLEFBQW5DLEFBQ0E7S0FBRSxNQUFNLEFBQVIsZUFBdUIsQUFBdkIsU0FBZ0MsQUFBaEMsWUFBNEMsQUFBNUMsQUFDQTtLQUFFLE1BQU0sQUFBUixlQUF1QixBQUF2QixTQUFnQyxBQUFoQyxLQUFxQyxBQUFyQyxrQkFBdUQsQUFBdkQsWUFBbUUsQUFBbkUsQUFDQTtBQUNEO1FBQU0sQUFBTixBQUNBO0FBWEQsQUFZQSIsImZpbGUiOiJzaGFyZV9idXR0b24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzaGFyZV9idXR0b25faW5pdCgkKSB7XG5cdCQoJy5zaGFyZS1idXR0b25zIC5jdGEnKS5jbGljayggKGV2ZW50KSA9PiB7XG5cdFx0aWYgKCAhJChldmVudC5jdXJyZW50VGFyZ2V0KS5oYXNDbGFzcygnb3BlbicpKSB7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLmFkZENsYXNzKCdvcGVuJyk7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLnBhcmVudCgpLmFkZENsYXNzKCdvcGVuJyk7XG5cdFx0XHQkKGV2ZW50LmN1cnJlbnRUYXJnZXQpLnBhcmVudCgpLmZpbmQoJy5zaGFyZS1idXR0b25zJykuYWRkQ2xhc3MoJ29wZW4nKTtcblx0XHR9IGVsc2Uge1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5yZW1vdmVDbGFzcygnb3BlbicpO1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5wYXJlbnQoKS5yZW1vdmVDbGFzcygnb3BlbicpO1xuXHRcdFx0JChldmVudC5jdXJyZW50VGFyZ2V0KS5wYXJlbnQoKS5maW5kKCcuc2hhcmUtYnV0dG9ucycpLnJlbW92ZUNsYXNzKCdvcGVuJyk7XG5cdFx0fVxuXHRcdGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG5cdH0pXG59Il19
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/components/share_button.js","/public/components")
},{"buffer":11,"rH1JPG":13}],3:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = header_menu_init;
function header_menu_init($) {

	$('.menu-primary-navigation-container').addClass('hide-nav-wrap');
	//	add a class to the nav container, in order to hide the container on mobile until opened

	$('.menu-primary-navigation-container .menu').addClass('grid-spaceAround hide-ul');
	//	add a class to the primary nav ul, in order to hide the nav in mobile view by default

	var navButton = document.getElementById("nav-menu-button"),
	    navUl = document.getElementsByClassName("menu grid-spaceAround"),
	    navWrap = document.getElementsByClassName("menu-primary-navigation-container");

	if (null === navButton) {
		return;
	}

	var mobileMenuOpen = false;

	function toggleMobileMenu() {
		if (mobileMenuOpen) {
			navUl[0].classList.add("hide-ul"), navWrap[0].classList.add("hide-nav-wrap");
			mobileMenuOpen = false;
		} else {
			navUl[0].classList.remove("hide-ul"), navWrap[0].classList.remove("hide-nav-wrap");
			mobileMenuOpen = true;
		}
	}
	//	add a class to the primary nav ul, in order to toggle hide the mobile nav via the burger

	if (navButton == null) {
		return;
	}

	navButton.onclick = toggleMobileMenu;
	//	remove the hide-ul class one the menu button is click in mobile view

	var burgerOpen = false;

	$('.burger').click(function () {
		if (burgerOpen) {
			$(this).removeClass('open');
			burgerOpen = false;
		} else {
			$(this).addClass('open');
			burgerOpen = true;
		}
	});

	$('.menu-item-has-children').addClass('has-subnav');
	//	add new has-subnav class to li's with subnav ul's

	if ($(".nav__item__text").length === 0) {
		$('.menu-primary-navigation-container .menu-item a').wrapInner('<span class="nav__item__text"></span>');
	}
	//	add a span to wrap the text in the header nav items

	var add_toggle_links = function add_toggle_links() {
		if ($('.menu-link').is(":visible")) {
			if ($(".toggle-link").length > 0) {} else {
				$('.has-subnav > a').after('<span class="toggle-link"></span>');
				$('.toggle-link').click(function (e) {
					var $this = $(this);
					$this.toggleClass('active').siblings('ul').toggleClass('active').parent('li').toggleClass('active');
				});
			}
		} else {
			$('.toggle-link').empty();
		}
	};
	//	add additional span element if nav-items have sub-nav items, if the burger is visible


	add_toggle_links();
	$(window).bind("resize", add_toggle_links);
	//	only run this code if the window has been resized

	var SPOTLIGHT = SPOTLIGHT || {};
	SPOTLIGHT.on = function (a, b) {};

	SPOTLIGHT.on("mobile.menu.open", function () {
		if (mobileMenuOpen) {
			toggleMobileMenu();
			$('.burger').removeClass('open');
		}
		return false;
	}); // this fails on local
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/header.js","/public")
},{"buffer":11,"rH1JPG":13}],4:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = tile_column_init;
function tile_column_init($) {
	$('.next-section').each(function (i, el) {

		$(el).click(function () {
			var target = '.' + $(el).data('target');

			$('html, body').animate({
				scrollTop: $(target).offset().top
			}, 1000);
		});
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpbGVfY29sdW1uLmpzIl0sIm5hbWVzIjpbInRpbGVfY29sdW1uX2luaXQiLCIkIiwiZWFjaCIsImkiLCJlbCIsImNsaWNrIiwidGFyZ2V0IiwiZGF0YSIsImFuaW1hdGUiLCJzY3JvbGxUb3AiLCJvZmZzZXQiLCJ0b3AiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNlLFNBQUEsQUFBUyxpQkFBVCxBQUEwQixHQUFHLEFBQzNDO0dBQUEsQUFBRSxpQkFBRixBQUFtQixLQUFNLFVBQUEsQUFBQyxHQUFELEFBQUksSUFBTyxBQUVuQzs7SUFBQSxBQUFFLElBQUYsQUFBTSxNQUFPLFlBQU0sQUFDbEI7T0FBSSxTQUFTLE1BQU0sRUFBQSxBQUFFLElBQUYsQUFBTSxLQUF6QixBQUFtQixBQUFXLEFBRTlCOztLQUFBLEFBQUUsY0FBRixBQUFnQjtlQUNKLEVBQUEsQUFBRSxRQUFGLEFBQVUsU0FEdEIsQUFBd0IsQUFDTztBQURQLEFBQ3ZCLE1BREQsQUFFRyxBQUNIO0FBTkQsQUFPQTtBQVRELEFBVUEiLCJmaWxlIjoidGlsZV9jb2x1bW4uanMiLCJzb3VyY2VzQ29udGVudCI6WyJcbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHRpbGVfY29sdW1uX2luaXQoJCkge1xuXHQkKCcubmV4dC1zZWN0aW9uJykuZWFjaCggKGksIGVsKSA9PiB7XG5cblx0XHQkKGVsKS5jbGljayggKCkgPT4ge1xuXHRcdFx0bGV0IHRhcmdldCA9ICcuJyArICQoZWwpLmRhdGEoJ3RhcmdldCcpO1xuXG5cdFx0XHQkKCdodG1sLCBib2R5JykuYW5pbWF0ZSh7XG5cdFx0XHRcdHNjcm9sbFRvcDogJCh0YXJnZXQpLm9mZnNldCgpLnRvcFxuXHRcdFx0fSwgMTAwMCk7XG5cdFx0fSk7XG5cdH0pO1xufSJdfQ==
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/items/tile_column.js","/public/items")
},{"buffer":11,"rH1JPG":13}],5:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = tile_travel_tabs_init;
function reset_all_tabs($) {
	$('.tab, .tab-content, tab-panel').removeClass('active');
}

function tile_travel_tabs_init($) {

	$('.tab-1, .tab-content-1, tab-panel-1').addClass('active');

	$('.tab').each(function (i, el) {
		$(el).click(function () {
			reset_all_tabs($);
			$('.tab-panel-' + (i + 1)).addClass('active');
			$('.tab-content-' + (i + 1)).addClass('active');
			$('.tab-' + (i + 1)).addClass('active');
		});
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRpbGVfdHJhdmVsX3RhYnMuanMiXSwibmFtZXMiOlsicmVzZXRfYWxsX3RhYnMiLCIkIiwicmVtb3ZlQ2xhc3MiLCJ0aWxlX3RyYXZlbF90YWJzX2luaXQiLCJhZGRDbGFzcyIsImVhY2giLCJpIiwiZWwiLCJjbGljayJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsU0FBUyxBQUFULGVBQXdCLEFBQXhCLEdBQTBCLEFBQ3pCO0dBQUUsQUFBRixpQ0FBbUMsQUFBbkMsWUFBK0MsQUFBL0MsQUFDQTtBQUVEOztBQUFlLFNBQVMsQUFBVCxzQkFBK0IsQUFBL0IsR0FBa0MsQUFFaEQ7O0dBQUUsQUFBRix1Q0FBeUMsQUFBekMsU0FBa0QsQUFBbEQsQUFFQTs7R0FBRSxBQUFGLFFBQVUsQUFBVixLQUFnQixVQUFDLEFBQUQsR0FBSSxBQUFKLElBQVcsQUFDMUI7SUFBRSxBQUFGLElBQU0sQUFBTixNQUFZLFlBQU0sQUFDakI7a0JBQWUsQUFBZixBQUNBO0tBQUUsaUJBQWlCLElBQUksQUFBckIsQUFBRixJQUEyQixBQUEzQixTQUFvQyxBQUFwQyxBQUNBO0tBQUUsbUJBQW1CLElBQUksQUFBdkIsQUFBRixJQUE2QixBQUE3QixTQUFzQyxBQUF0QyxBQUNBO0tBQUUsV0FBVyxJQUFJLEFBQWYsQUFBRixJQUFxQixBQUFyQixTQUE4QixBQUE5QixBQUNBO0FBTEQsQUFNQTtBQVBELEFBUUEiLCJmaWxlIjoidGlsZV90cmF2ZWxfdGFicy5qcyIsInNvdXJjZXNDb250ZW50IjpbImZ1bmN0aW9uIHJlc2V0X2FsbF90YWJzKCQpe1xuXHQkKCcudGFiLCAudGFiLWNvbnRlbnQsIHRhYi1wYW5lbCcpLnJlbW92ZUNsYXNzKCdhY3RpdmUnKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdGlsZV90cmF2ZWxfdGFic19pbml0KCQpIHtcblxuXHQkKCcudGFiLTEsIC50YWItY29udGVudC0xLCB0YWItcGFuZWwtMScpLmFkZENsYXNzKCdhY3RpdmUnKTtcblxuXHQkKCcudGFiJykuZWFjaCggKGksIGVsKSA9PiB7XG5cdFx0JChlbCkuY2xpY2soKCkgPT4ge1xuXHRcdFx0cmVzZXRfYWxsX3RhYnMoJCk7XG5cdFx0XHQkKCcudGFiLXBhbmVsLScgKyAoaSArIDEpKS5hZGRDbGFzcygnYWN0aXZlJyk7XG5cdFx0XHQkKCcudGFiLWNvbnRlbnQtJyArIChpICsgMSkpLmFkZENsYXNzKCdhY3RpdmUnKTtcblx0XHRcdCQoJy50YWItJyArIChpICsgMSkpLmFkZENsYXNzKCdhY3RpdmUnKTtcblx0XHR9KTtcblx0fSk7XG59Il19
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/items/tile_travel_tabs.js","/public/items")
},{"buffer":11,"rH1JPG":13}],6:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = heritage_slider_init;
function heritage_slider_init($) {
	$(window).resize(function () {
		if ($(window).width() < 768) {
			if (!$('.heritage-slider .section__group').hasClass('slick-slider')) {
				$('.heritage-slider .section__group').slick({
					dots: true,
					adaptiveHeight: true,
					autoplay: false,
					autoplaySpeed: 3100,
					pauseOnHover: false,
					speed: 750,
					cssEase: 'linear',
					slidesToShow: 1,
					slidesToScroll: 1,
					responsive: [{
						breakpoint: 1000000,
						settings: 'unslick'
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}]
				});
			}
		}
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/heritage_slider.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],7:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = page_navigation_init;
function page_navigation_init($) {

	var currentPos = 1;
	var count = $('.inpage-nav').data('count');

	var sectionsTop = $('.' + $('.nav-item-' + 1).attr('href')).offset().top;
	var sectionsBottom = $('.' + $('.nav-item-' + count).attr('href')).offset().top;

	function go_to_pos(targetPos) {
		show_pos(targetPos, false);

		var target = '.' + $('.nav-item-' + currentPos).attr('href');

		$('html, body').animate({
			scrollTop: $(target).offset().top
		}, 1000);
	}

	function maybe_go_to_pos(targetPos) {
		if (targetPos > 0 && targetPos <= count && targetPos != currentPos) {
			go_to_pos(targetPos);
		}
	}

	function maybe_go_up() {
		maybe_go_to_pos(currentPos - 1);
	}

	function maybe_go_down() {
		maybe_go_to_pos(currentPos + 1);
	}

	function show_pos(targetPos) {
		var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		$('.mark').removeClass('active');
		$('.nav-item-' + currentPos).removeClass('active');
		currentPos = Math.floor(targetPos);
		if (!show) {
			return;
		}
		if (!Number.isInteger(targetPos)) {
			var subpos = targetPos % 1;
			if (subpos < 0.2) {
				show_pos(Math.floor(targetPos));
			} else if (subpos > 0.2 && subpos < 0.5) {
				$('.mark-' + currentPos + '-1').addClass('active');
			} else if (subpos >= 0.5 && subpos < 0.8) {
				$('.mark-' + currentPos + '-2').addClass('active');
			} else {
				show_pos(Math.floor(targetPos) + 1);
			}
		} else {
			$('.nav-item-' + currentPos).addClass('active');
		}
	}

	function show_pos_by_percent(percent) {
		var percent = Math.min(100, Math.max(0, percent));

		var target = percent / 100 * (count - 1) + 1;

		show_pos(target);
	}

	function reposition_nav(distance) {
		if (distance < 0) {
			$('.section.page_navigation').css({ top: Math.max(0, 0 - distance) });
		} else if (distance + sectionsTop > sectionsBottom) {
			$('.section.page_navigation').css({ top: -(distance + sectionsTop - sectionsBottom) });
		} else {
			$('.section.page_navigation').css({ top: 0 });
		}
	}

	$('.nav-item').each(function (i, item) {
		$(item).click(function (e) {
			e.preventDefault();

			var targetPos = $(item).data('position');
			maybe_go_to_pos(targetPos);
		});
	});

	$('.nav-up').click(maybe_go_up);

	$('.nav-down').click(maybe_go_down);

	function handleScroll(e) {
		sectionsTop = $('.' + $('.nav-item-' + 1).attr('href')).offset().top;
		sectionsBottom = $('.' + $('.nav-item-' + count).attr('href')).offset().top;

		var footerTop = Math.max(0, $(window).scrollTop() + $(window).height() - $('.in-page-footer').offset().top);

		var scroll = $(window).scrollTop() - sectionsTop;
		var scrollMax = sectionsBottom - sectionsTop;

		reposition_nav(0 === footerTop ? scroll : sectionsBottom - sectionsTop + footerTop);

		show_pos_by_percent(scroll / scrollMax * 100);
	};

	$(window).scroll(handleScroll);
	setTimeout(function () {
		try {
			// Potential the next line can fail due to the age gate loading
			handleScroll();
		} catch (error) {
			setTimeout(handleScroll, 1000);
		}
	}, 100);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/page_navigation.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],8:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = responsive_slider_init;
// Sliders used for botanicals

function responsive_slider_init($) {
	$('.slick-slider.responsive-slider-2').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3400,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 2,
		infinite: true,
		lazyLoad: 'ondemand',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true
			}
		}, {
			breakpoint: 520,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

	$('.slick-slider.responsive-slider-3').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 3,
		infinite: true,
		lazyLoad: 'ondemand',
		responsive: [{
			breakpoint: 820,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

	$('.slick-slider.responsive-slider-4').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 4,
		slidesToScroll: 4,
		infinite: true,
		lazyLoad: 'ondemand',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 2,
				infinite: true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}]
	});

	$('.slick-slider.responsive-slider-4-cocktail').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		lazyLoad: 'ondemand',
		arrows: true,
		appendArrows: '.slider-nav',
		appendDots: '.slider-nav',
		responsive: [{
			breakpoint: 1026,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

	$('.slick-slider.responsive-slider-5').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 5,
		slidesToScroll: 4,
		infinite: true,
		lazyLoad: 'ondemand',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}]
	});

	// original About us botanicals slider

	$('.slick-slider.responsive-slider-7').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 3100,
		pauseOnHover: false,
		speed: 750,
		cssEase: 'ease-in-out',
		slidesToShow: 7,
		slidesToScroll: 0,
		infinite: true,
		lazyLoad: 'ondemand',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 4,
				infinite: true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}]
	});

	// Revised About us - botanicals slider

	$('.slick-slider.dual-slider-header').slick({
		// adaptiveHeight: true,
		speed: 500,
		slidesToShow: 10,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		asNavFor: '.slick-slider.dual-slider-body',
		responsive: [{
			breakpoint: 1030,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				centerMode: true
			}
		}, {
			breakpoint: 340,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				centerMode: true
			}
		}]
	});

	$('.slick-slider.dual-slider-body').slick({
		adaptiveHeight: true,
		speed: 500,
		slidesToShow: 1,
		fade: true,
		slidesToScroll: 1,
		infinite: true,
		dots: true,
		arrows: true,
		asNavFor: '.slick-slider.dual-slider-header',
		appendArrows: '.slider-nav',
		appendDots: '.slider-nav'
	});

	$(document).load(function (event, slick) {
		$('.slick-slider.dual-slider-header').slick("refresh");
		$('.slick-slider.dual-slider-body').slick("refresh");
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		goto_slide(nextSlide);
	});

	function goto_slide(slide_number) {
		var needs_nav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


		if (needs_nav) {
			$('.slick-slider.dual-slider-body').slick('slickGoTo', slide_number);
		}

		var target_pos = $('*[data-slick-index="' + slide_number + '"]').position();

		$('.slide-highlight').css('left', target_pos.left);
	}

	$('.dual-slider-header .section__item').click(function (e) {
		goto_slide($(e.currentTarget).data('slick-index'), true);
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/responsive_slider.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],9:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = slider_contained_one_column_init;
function slider_contained_one_column_init($) {

	var activeClass = 'slick-active',
	    ariaAttribute = 'aria-hidden';

	$('.slick-slider .section__group').on('init', function () {
		$('.slick-dots li:first-of-type').addClass(activeClass).attr(ariaAttribute, false);
	})

	//	Force the first slide to apend the active class to the slider pagination

	.on('afterChange', function (event, slick, currentSlide) {
		var $dots = $('.slick-dots');
		$('li', $dots).removeClass(activeClass).attr(ariaAttribute, true);
		$dots.each(function () {
			$('li', $(this)).eq(currentSlide).addClass(activeClass).attr(ariaAttribute, false);
		});
	});

	//	Force the active class on to the li of the current slide
	//	Both of the above are necessary to append the dots inside each slide instead of outside the slie items

	$('.slick-slider .section__group').slick({
		dots: true,
		adaptiveHeight: true,
		autoplay: false,
		autoplaySpeed: 6000,
		pauseOnHover: false,
		speed: 750,
		fade: true,
		cssEase: 'ease-in-out',
		appendDots: '.hero__slider__content' //	See notes above to fix the consequence of moving the slide dots
	});
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/public/sections/slider_contained_one_column.js","/public/sections")
},{"buffer":11,"rH1JPG":13}],10:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/base64-js/lib/b64.js","/../../node_modules/base64-js/lib")
},{"buffer":11,"rH1JPG":13}],11:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = Buffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192

/**
 * If `Buffer._useTypedArrays`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (compatible down to IE6)
 */
Buffer._useTypedArrays = (function () {
  // Detect if browser supports Typed Arrays. Supported browsers are IE 10+, Firefox 4+,
  // Chrome 7+, Safari 5.1+, Opera 11.6+, iOS 4.2+. If the browser does not support adding
  // properties to `Uint8Array` instances, then that's the same as no `Uint8Array` support
  // because we need to be able to add all the node Buffer API methods. This is an issue
  // in Firefox 4-29. Now fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=695438
  try {
    var buf = new ArrayBuffer(0)
    var arr = new Uint8Array(buf)
    arr.foo = function () { return 42 }
    return 42 === arr.foo() &&
        typeof arr.subarray === 'function' // Chrome 9-10 lack `subarray`
  } catch (e) {
    return false
  }
})()

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (subject, encoding, noZero) {
  if (!(this instanceof Buffer))
    return new Buffer(subject, encoding, noZero)

  var type = typeof subject

  // Workaround: node's base64 implementation allows for non-padded strings
  // while base64-js does not.
  if (encoding === 'base64' && type === 'string') {
    subject = stringtrim(subject)
    while (subject.length % 4 !== 0) {
      subject = subject + '='
    }
  }

  // Find the length
  var length
  if (type === 'number')
    length = coerce(subject)
  else if (type === 'string')
    length = Buffer.byteLength(subject, encoding)
  else if (type === 'object')
    length = coerce(subject.length) // assume that object is array-like
  else
    throw new Error('First argument needs to be a number, array or string.')

  var buf
  if (Buffer._useTypedArrays) {
    // Preferred: Return an augmented `Uint8Array` instance for best performance
    buf = Buffer._augment(new Uint8Array(length))
  } else {
    // Fallback: Return THIS instance of Buffer (created by `new`)
    buf = this
    buf.length = length
    buf._isBuffer = true
  }

  var i
  if (Buffer._useTypedArrays && typeof subject.byteLength === 'number') {
    // Speed optimization -- use set if we're copying from a typed array
    buf._set(subject)
  } else if (isArrayish(subject)) {
    // Treat array-ish objects as a byte array
    for (i = 0; i < length; i++) {
      if (Buffer.isBuffer(subject))
        buf[i] = subject.readUInt8(i)
      else
        buf[i] = subject[i]
    }
  } else if (type === 'string') {
    buf.write(subject, 0, encoding)
  } else if (type === 'number' && !Buffer._useTypedArrays && !noZero) {
    for (i = 0; i < length; i++) {
      buf[i] = 0
    }
  }

  return buf
}

// STATIC METHODS
// ==============

Buffer.isEncoding = function (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.isBuffer = function (b) {
  return !!(b !== null && b !== undefined && b._isBuffer)
}

Buffer.byteLength = function (str, encoding) {
  var ret
  str = str + ''
  switch (encoding || 'utf8') {
    case 'hex':
      ret = str.length / 2
      break
    case 'utf8':
    case 'utf-8':
      ret = utf8ToBytes(str).length
      break
    case 'ascii':
    case 'binary':
    case 'raw':
      ret = str.length
      break
    case 'base64':
      ret = base64ToBytes(str).length
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = str.length * 2
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.concat = function (list, totalLength) {
  assert(isArray(list), 'Usage: Buffer.concat(list, [totalLength])\n' +
      'list should be an Array.')

  if (list.length === 0) {
    return new Buffer(0)
  } else if (list.length === 1) {
    return list[0]
  }

  var i
  if (typeof totalLength !== 'number') {
    totalLength = 0
    for (i = 0; i < list.length; i++) {
      totalLength += list[i].length
    }
  }

  var buf = new Buffer(totalLength)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

// BUFFER INSTANCE METHODS
// =======================

function _hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  assert(strLen % 2 === 0, 'Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var byte = parseInt(string.substr(i * 2, 2), 16)
    assert(!isNaN(byte), 'Invalid hex string')
    buf[offset + i] = byte
  }
  Buffer._charsWritten = i * 2
  return i
}

function _utf8Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf8ToBytes(string), buf, offset, length)
  return charsWritten
}

function _asciiWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(asciiToBytes(string), buf, offset, length)
  return charsWritten
}

function _binaryWrite (buf, string, offset, length) {
  return _asciiWrite(buf, string, offset, length)
}

function _base64Write (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(base64ToBytes(string), buf, offset, length)
  return charsWritten
}

function _utf16leWrite (buf, string, offset, length) {
  var charsWritten = Buffer._charsWritten =
    blitBuffer(utf16leToBytes(string), buf, offset, length)
  return charsWritten
}

Buffer.prototype.write = function (string, offset, length, encoding) {
  // Support both (string, offset, length, encoding)
  // and the legacy (string, encoding, offset, length)
  if (isFinite(offset)) {
    if (!isFinite(length)) {
      encoding = length
      length = undefined
    }
  } else {  // legacy
    var swap = encoding
    encoding = offset
    offset = length
    length = swap
  }

  offset = Number(offset) || 0
  var remaining = this.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }
  encoding = String(encoding || 'utf8').toLowerCase()

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexWrite(this, string, offset, length)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Write(this, string, offset, length)
      break
    case 'ascii':
      ret = _asciiWrite(this, string, offset, length)
      break
    case 'binary':
      ret = _binaryWrite(this, string, offset, length)
      break
    case 'base64':
      ret = _base64Write(this, string, offset, length)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leWrite(this, string, offset, length)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toString = function (encoding, start, end) {
  var self = this

  encoding = String(encoding || 'utf8').toLowerCase()
  start = Number(start) || 0
  end = (end !== undefined)
    ? Number(end)
    : end = self.length

  // Fastpath empty strings
  if (end === start)
    return ''

  var ret
  switch (encoding) {
    case 'hex':
      ret = _hexSlice(self, start, end)
      break
    case 'utf8':
    case 'utf-8':
      ret = _utf8Slice(self, start, end)
      break
    case 'ascii':
      ret = _asciiSlice(self, start, end)
      break
    case 'binary':
      ret = _binarySlice(self, start, end)
      break
    case 'base64':
      ret = _base64Slice(self, start, end)
      break
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      ret = _utf16leSlice(self, start, end)
      break
    default:
      throw new Error('Unknown encoding')
  }
  return ret
}

Buffer.prototype.toJSON = function () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function (target, target_start, start, end) {
  var source = this

  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (!target_start) target_start = 0

  // Copy 0 bytes; we're done
  if (end === start) return
  if (target.length === 0 || source.length === 0) return

  // Fatal error conditions
  assert(end >= start, 'sourceEnd < sourceStart')
  assert(target_start >= 0 && target_start < target.length,
      'targetStart out of bounds')
  assert(start >= 0 && start < source.length, 'sourceStart out of bounds')
  assert(end >= 0 && end <= source.length, 'sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length)
    end = this.length
  if (target.length - target_start < end - start)
    end = target.length - target_start + start

  var len = end - start

  if (len < 100 || !Buffer._useTypedArrays) {
    for (var i = 0; i < len; i++)
      target[i + target_start] = this[i + start]
  } else {
    target._set(this.subarray(start, start + len), target_start)
  }
}

function _base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function _utf8Slice (buf, start, end) {
  var res = ''
  var tmp = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    if (buf[i] <= 0x7F) {
      res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i])
      tmp = ''
    } else {
      tmp += '%' + buf[i].toString(16)
    }
  }

  return res + decodeUtf8Char(tmp)
}

function _asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++)
    ret += String.fromCharCode(buf[i])
  return ret
}

function _binarySlice (buf, start, end) {
  return _asciiSlice(buf, start, end)
}

function _hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function _utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i+1] * 256)
  }
  return res
}

Buffer.prototype.slice = function (start, end) {
  var len = this.length
  start = clamp(start, len, 0)
  end = clamp(end, len, len)

  if (Buffer._useTypedArrays) {
    return Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    var newBuf = new Buffer(sliceLen, undefined, true)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
    return newBuf
  }
}

// `get` will be removed in Node 0.13+
Buffer.prototype.get = function (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` will be removed in Node 0.13+
Buffer.prototype.set = function (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

Buffer.prototype.readUInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  return this[offset]
}

function _readUInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    val = buf[offset]
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
  } else {
    val = buf[offset] << 8
    if (offset + 1 < len)
      val |= buf[offset + 1]
  }
  return val
}

Buffer.prototype.readUInt16LE = function (offset, noAssert) {
  return _readUInt16(this, offset, true, noAssert)
}

Buffer.prototype.readUInt16BE = function (offset, noAssert) {
  return _readUInt16(this, offset, false, noAssert)
}

function _readUInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val
  if (littleEndian) {
    if (offset + 2 < len)
      val = buf[offset + 2] << 16
    if (offset + 1 < len)
      val |= buf[offset + 1] << 8
    val |= buf[offset]
    if (offset + 3 < len)
      val = val + (buf[offset + 3] << 24 >>> 0)
  } else {
    if (offset + 1 < len)
      val = buf[offset + 1] << 16
    if (offset + 2 < len)
      val |= buf[offset + 2] << 8
    if (offset + 3 < len)
      val |= buf[offset + 3]
    val = val + (buf[offset] << 24 >>> 0)
  }
  return val
}

Buffer.prototype.readUInt32LE = function (offset, noAssert) {
  return _readUInt32(this, offset, true, noAssert)
}

Buffer.prototype.readUInt32BE = function (offset, noAssert) {
  return _readUInt32(this, offset, false, noAssert)
}

Buffer.prototype.readInt8 = function (offset, noAssert) {
  if (!noAssert) {
    assert(offset !== undefined && offset !== null,
        'missing offset')
    assert(offset < this.length, 'Trying to read beyond buffer length')
  }

  if (offset >= this.length)
    return

  var neg = this[offset] & 0x80
  if (neg)
    return (0xff - this[offset] + 1) * -1
  else
    return this[offset]
}

function _readInt16 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt16(buf, offset, littleEndian, true)
  var neg = val & 0x8000
  if (neg)
    return (0xffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt16LE = function (offset, noAssert) {
  return _readInt16(this, offset, true, noAssert)
}

Buffer.prototype.readInt16BE = function (offset, noAssert) {
  return _readInt16(this, offset, false, noAssert)
}

function _readInt32 (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  var len = buf.length
  if (offset >= len)
    return

  var val = _readUInt32(buf, offset, littleEndian, true)
  var neg = val & 0x80000000
  if (neg)
    return (0xffffffff - val + 1) * -1
  else
    return val
}

Buffer.prototype.readInt32LE = function (offset, noAssert) {
  return _readInt32(this, offset, true, noAssert)
}

Buffer.prototype.readInt32BE = function (offset, noAssert) {
  return _readInt32(this, offset, false, noAssert)
}

function _readFloat (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 3 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 23, 4)
}

Buffer.prototype.readFloatLE = function (offset, noAssert) {
  return _readFloat(this, offset, true, noAssert)
}

Buffer.prototype.readFloatBE = function (offset, noAssert) {
  return _readFloat(this, offset, false, noAssert)
}

function _readDouble (buf, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset + 7 < buf.length, 'Trying to read beyond buffer length')
  }

  return ieee754.read(buf, offset, littleEndian, 52, 8)
}

Buffer.prototype.readDoubleLE = function (offset, noAssert) {
  return _readDouble(this, offset, true, noAssert)
}

Buffer.prototype.readDoubleBE = function (offset, noAssert) {
  return _readDouble(this, offset, false, noAssert)
}

Buffer.prototype.writeUInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'trying to write beyond buffer length')
    verifuint(value, 0xff)
  }

  if (offset >= this.length) return

  this[offset] = value
}

function _writeUInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 2); i < j; i++) {
    buf[offset + i] =
        (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt16BE = function (value, offset, noAssert) {
  _writeUInt16(this, value, offset, false, noAssert)
}

function _writeUInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'trying to write beyond buffer length')
    verifuint(value, 0xffffffff)
  }

  var len = buf.length
  if (offset >= len)
    return

  for (var i = 0, j = Math.min(len - offset, 4); i < j; i++) {
    buf[offset + i] =
        (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeUInt32BE = function (value, offset, noAssert) {
  _writeUInt32(this, value, offset, false, noAssert)
}

Buffer.prototype.writeInt8 = function (value, offset, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset < this.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7f, -0x80)
  }

  if (offset >= this.length)
    return

  if (value >= 0)
    this.writeUInt8(value, offset, noAssert)
  else
    this.writeUInt8(0xff + value + 1, offset, noAssert)
}

function _writeInt16 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 1 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fff, -0x8000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt16(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt16(buf, 0xffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt16LE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt16BE = function (value, offset, noAssert) {
  _writeInt16(this, value, offset, false, noAssert)
}

function _writeInt32 (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifsint(value, 0x7fffffff, -0x80000000)
  }

  var len = buf.length
  if (offset >= len)
    return

  if (value >= 0)
    _writeUInt32(buf, value, offset, littleEndian, noAssert)
  else
    _writeUInt32(buf, 0xffffffff + value + 1, offset, littleEndian, noAssert)
}

Buffer.prototype.writeInt32LE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, true, noAssert)
}

Buffer.prototype.writeInt32BE = function (value, offset, noAssert) {
  _writeInt32(this, value, offset, false, noAssert)
}

function _writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 3 < buf.length, 'Trying to write beyond buffer length')
    verifIEEE754(value, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 23, 4)
}

Buffer.prototype.writeFloatLE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function (value, offset, noAssert) {
  _writeFloat(this, value, offset, false, noAssert)
}

function _writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    assert(value !== undefined && value !== null, 'missing value')
    assert(typeof littleEndian === 'boolean', 'missing or invalid endian')
    assert(offset !== undefined && offset !== null, 'missing offset')
    assert(offset + 7 < buf.length,
        'Trying to write beyond buffer length')
    verifIEEE754(value, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }

  var len = buf.length
  if (offset >= len)
    return

  ieee754.write(buf, value, offset, littleEndian, 52, 8)
}

Buffer.prototype.writeDoubleLE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function (value, offset, noAssert) {
  _writeDouble(this, value, offset, false, noAssert)
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (typeof value === 'string') {
    value = value.charCodeAt(0)
  }

  assert(typeof value === 'number' && !isNaN(value), 'value is not a number')
  assert(end >= start, 'end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  assert(start >= 0 && start < this.length, 'start out of bounds')
  assert(end >= 0 && end <= this.length, 'end out of bounds')

  for (var i = start; i < end; i++) {
    this[i] = value
  }
}

Buffer.prototype.inspect = function () {
  var out = []
  var len = this.length
  for (var i = 0; i < len; i++) {
    out[i] = toHex(this[i])
    if (i === exports.INSPECT_MAX_BYTES) {
      out[i + 1] = '...'
      break
    }
  }
  return '<Buffer ' + out.join(' ') + '>'
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer._useTypedArrays) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1)
        buf[i] = this[i]
      return buf.buffer
    }
  } else {
    throw new Error('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function (arr) {
  arr._isBuffer = true

  // save reference to original Uint8Array get/set methods before overwriting
  arr._get = arr.get
  arr._set = arr.set

  // deprecated, will be removed in node 0.13+
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

// slice(start, end)
function clamp (index, len, defaultValue) {
  if (typeof index !== 'number') return defaultValue
  index = ~~index;  // Coerce to integer.
  if (index >= len) return len
  if (index >= 0) return index
  index += len
  if (index >= 0) return index
  return 0
}

function coerce (length) {
  // Coerce length to a number (possibly NaN), round up
  // in case it's fractional (e.g. 123.456) then do a
  // double negate to coerce a NaN to 0. Easy, right?
  length = ~~Math.ceil(+length)
  return length < 0 ? 0 : length
}

function isArray (subject) {
  return (Array.isArray || function (subject) {
    return Object.prototype.toString.call(subject) === '[object Array]'
  })(subject)
}

function isArrayish (subject) {
  return isArray(subject) || Buffer.isBuffer(subject) ||
      subject && typeof subject === 'object' &&
      typeof subject.length === 'number'
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    var b = str.charCodeAt(i)
    if (b <= 0x7F)
      byteArray.push(str.charCodeAt(i))
    else {
      var start = i
      if (b >= 0xD800 && b <= 0xDFFF) i++
      var h = encodeURIComponent(str.slice(start, i+1)).substr(1).split('%')
      for (var j = 0; j < h.length; j++)
        byteArray.push(parseInt(h[j], 16))
    }
  }
  return byteArray
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(str)
}

function blitBuffer (src, dst, offset, length) {
  var pos
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length))
      break
    dst[i + offset] = src[i]
  }
  return i
}

function decodeUtf8Char (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    return String.fromCharCode(0xFFFD) // UTF 8 invalid char
  }
}

/*
 * We have to make sure that the value is a valid integer. This means that it
 * is non-negative. It has no fractional component and that it does not
 * exceed the maximum allowed value.
 */
function verifuint (value, max) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value >= 0, 'specified a negative value for writing an unsigned value')
  assert(value <= max, 'value is larger than maximum value for type')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifsint (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
  assert(Math.floor(value) === value, 'value has a fractional component')
}

function verifIEEE754 (value, max, min) {
  assert(typeof value === 'number', 'cannot write a non-number as a number')
  assert(value <= max, 'value larger than maximum allowed value')
  assert(value >= min, 'value smaller than minimum allowed value')
}

function assert (test, message) {
  if (!test) throw new Error(message || 'Failed assertion')
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/buffer/index.js","/../../node_modules/buffer")
},{"base64-js":10,"buffer":11,"ieee754":12,"rH1JPG":13}],12:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/ieee754/index.js","/../../node_modules/ieee754")
},{"buffer":11,"rH1JPG":13}],13:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/../../node_modules/process/browser.js","/../../node_modules/process")
},{"buffer":11,"rH1JPG":13}]},{},[1])